import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp3-escape-from-azkaban",
  name: `The Daily Prophet\n'Escape from Azkaban!'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Escape from Azkaban!'",
  },
  origin: "Harry Potter and the Prisoner of Azkaban",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
